(function ($) {

    $.fn.jobsRest = function () {
        console.log('here')
        var that = this;
        var container = $(this).find('.js-jobs').first();
        var category = that.data('category');
        var firmId = that.data('firm-id');
        var apiUrl = that.data('api-url');


        var template = null;
        var nextUrl = null;
        var args = {
            'posts_per_page': 6,
            'page': 0,
            'category': category,
        }

        function hideButton() {
            $('.js-load-more').addClass('hide');
        }

        function showButton() {
            $('.js-load-more').removeClass('hide');
        }

        $('.js-load-more').on('click', function () {
            args.page = args.page + 1;
            getJobs(false);
        })

        function getJobs(replace, params) {
            that.addClass('is-loading')

            if (replace) {
                container.html('');
            }


            $.ajax({
                type: 'GET',
                url: nextUrl ? nextUrl : apiUrl + "jobs/" + firmId + "/minisite",
                data: params,
                success: function (res) {
                    nextUrl = res.next;

                    var items = res.results;

                    items.map(function(item) {
                        item.published_date = getDate(item.published_date)
                        item.created_at = getDate(item.created_at)
                    })

                    $.get({
                        url: '/wp-content/themes/5x5/templates/jobs.html',
                        success: function (html) {
                            template = Handlebars.compile(html);

                            items = template({
                                items: items
                            })
                            if (nextUrl) {
                                showButton();
                            } else {
                                hideButton();
                            }
                            container.append(items);
                            that.removeClass('is-loading')
                            setIntersections();
                            initToShow();
                        },
                        error: function (err) {
                            console.log(err);
                        }
                    })
                },
            })
        }
        getJobs(true);
    }
}(jQuery));

$(function () {
    if ($('#js-jobs').length) {
        $('#js-jobs').jobsRest();
    }
});


function getDate(date) {
    var d = new Date(date);
    var day = d.getDay() < 10 ? '0' + d.getDay() : d.getDay();
    var month = parseInt(d.getMonth()) + 1 < 10 ? '0' + (parseInt(d.getMonth()) + 1) : parseInt(d.getMonth()) + 1;
    return day + '/' + month + '/' + d.getFullYear();
}